import script from "./ZhinengGG.vue?vue&type=script&setup=true&lang=js"
export * from "./ZhinengGG.vue?vue&type=script&setup=true&lang=js"

import "./ZhinengGG.vue?vue&type=style&index=0&id=a4770f18&lang=less&scoped=true"
script.__scopeId = "data-v-a4770f18"

export default script